import CheckboxCol from 'components/form-elements/CheckboxCol';
import Card from 'components/ui-elements/Card';
import Row from 'components/ui-elements/Row';
import useAxiosFunction from 'hooks/useAxiosFunction';
import React, { Fragment, useEffect, useState } from 'react'

const ListCheckbox = (props) => {
    const [respax, errax, loadingax, fetchax] = useAxiosFunction();
    const { checklist = [], itemcolsize = 3, valueId, labelId, label, editid, disabled, selectedlist, defaultValue, selectedurl, name, onChange, ...rest } = props
    const [arrselected, setArrselected] = useState([])

    useEffect(() => {
        if (Array.isArray(selectedlist) && selectedlist.length > 0) {
            const myarrselected = selectedlist.map(selected => selected?.[valueId])
            setArrselected(myarrselected)
        }

        const defaultSelected = defaultValue?.[name]
        if (Array.isArray(defaultSelected)) {
            setArrselected(defaultSelected.map((item) => item?.[valueId] ?? item))
        }

        if (selectedurl && editid && defaultValue) {
            const selectedlisturl = defaultValue?.[editid] ? selectedurl + "/" + defaultValue?.[editid] : ""
            if (selectedlisturl) {
                fetchax({ method: "GET", url: selectedlisturl, auth: true })
            }
        }
    }, [defaultValue, editid, name, selectedlist, selectedurl, valueId])


    useEffect(() => {
        if (!Array.isArray(respax?.data)) return
        const tmparrselected = respax.data.map(selected => selected?.[valueId])
        setArrselected(tmparrselected)
    }, [respax, valueId])

    return (
        <Fragment>

            <Card title={label} mb="0">
                <Row>
                    {checklist && checklist.map((item, idx) => {
                        const checked = arrselected ? arrselected.includes(item?.[valueId]) : false
                        const ok = defaultValue ? defaultValue && arrselected : true
                        return ok && <CheckboxCol
                            onChange={onChange}
                            defaultChecked={checked}
                            disabled={disabled}
                            margin="mb-0"
                            key={item?.[valueId] || idx}
                            colsize={itemcolsize}
                            name={name}
                            value={item?.[valueId]}
                            {...rest}
                            label={item?.[labelId]}
                        />
                    })}
                </Row>
            </Card>

        </Fragment>

    )
}
ListCheckbox.defaultProps = {
    label: "",
    disabled: false,
    selectedlist: [],
    onChange: () => { }
}
export default ListCheckbox
